export default {
	"银行卡信息":"Bank card information",
	"信用分": "Kreditwürdigkeit",
	"语言":"Sprache",
	"首页":"Heim",
	"电影":"Film",
	"我的": "meins",
	"请求失败":"Die Anfrage ist fehlgeschlagen",
	"选妃":"TemuCinta",
	"高端": "High-End",
	"认证":"Zertifikat",
	"视频认证":"Videoauthentifizierung",
	"收费区间":"Lastbereich",
	"身高":"Höhe",
	"胸围": "Brustumfang",
	"服务城市：全国各地 航空运输：是":"Bediente Städte: Landesweit Luftverkehr: Ja",
	"我要约她":"Ich möchte mit ihr ausgehen",
	"住所":"Residenz",
	"个人简介":"Profil",
	"请联系顾问或接待员":"Bitte wenden Sie sich an einen Berater oder eine Rezeptionistin",
	"投票":"Abstimmung",
	"全部":"alle",
	"刷新成功": "Aktualisierung erfolgreich",
	"尽享高端区":"Genießen Sie das gehobene Viertel",
	"享受极致奢华体验":"Genießen Sie das ultimative Luxus-Erlebnis",
	"空降":"in der Luft",
	"查看更多":"Mehr sehen",
	"热门推荐":"Beliebte Empfehlungen",
	"获取中":"Erhalten",
	"登录": "Einloggen",
	"忘记密码":"Passwort vergessen",
	"没有账户？马上注册":"Sie haben noch kein Konto? Registrieren Sie sich jetzt",
	"请输入用户名":"Bitte geben Sie Ihren Benutzernamen ein",
	"请输入密码":"Bitte geben Sie das Passwort ein",
	"注册":"registrieren",
	"请输入用户名(6-12个英文字母或数字)":"Bitte geben Sie Ihren Benutzernamen ein (6 bis 12 englische Buchstaben oder Zahlen)",
	"请输入登录密码(6-12个英文字母或数字)":"Bitte geben Sie Ihr Login-Passwort ein (6 bis 12 englische Buchstaben oder Zahlen)",
	"我已经知晓并同意开户协议各项条约":"Ich habe die Bedingungen der Kontoeröffnungsvereinbarung verstanden und akzeptiert",
	"请输入邀请码":"Bitte geben Sie den Einladungscode ein",
	"请勾选下方开户协议":"Die Kontoeröffnungsvereinbarung finden Sie weiter unten.",
	"投票结果":"Abstimmungsergebnisse",
	"提交":"einreichen",
	"当前选号": "Aktuelle Auswahl",
	"每注金额":"Betrag pro Wette",
	"请输入金额": "Bitte geben Sie den Betrag ein",
	"元":"€",
	"总共":"Gesamt",
	"注":"Notiz",
	"合计":"Gesamt",
	"任务单": "Reihenfolge der Aufgaben",
	"清空订单":"Löschen Sie die Bestellung",
	"确认提交":"Bestätigen Sie die Übermittlung",
	"期号":"Seriennummer",
	"中奖号码":"Gewinnzahlen",
	"鲜花":"Blumen",
	"气球":"Ball",
	"棒棒糖":"Lutscher",
	"烟花": "Feuerwerk",
	"未选择":"Nicht ausgewählt",
	"金额错误":"Falscher Betrag",
	"请选号":"Bitte wählen Sie eine Nummer aus",
	"请填写金额":"Bitte geben Sie den Betrag ein",
	"余额不足，请联系客服充值":"Sollte das Guthaben nicht ausreichen, kontaktieren Sie bitte den Kundenservice, um Ihr Guthaben aufzuladen.",
	"未选中":"Nicht ausgewählt",
	"请联系管理员领取该任务": "Bitte wenden Sie sich an den Administrator, um diese Aufgabe zu erhalten",
	"开奖成功，期号：":"Die Ziehung war erfolgreich, Ausgabenummer:",
	"请输入您的收款卡信息":"Bitte geben Sie Ihre Zahlungskarteninformationen ein",
	"银行卡号": "Kartennummer",
	"请输入真实银行卡号": "Bitte geben Sie Ihre echte Kreditkartennummer ein",
	"银行名称":"Name der Bank",
	"尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款":"Sehr geehrter Benutzer, um die Sicherheit Ihres Geldes zu gewährleisten, verknüpfen Sie bitte Ihren richtigen Namen und legen Sie ein Auszahlungskennwort fest. Wenn Ihr Name nicht mit dem Namen bei der Kontoeröffnung übereinstimmt, können Sie kein Geld abheben..",
	"确认绑卡":"Bestätigen Sie die Kartenbindung",
	"请输入银行卡号":"Bitte geben Sie Ihre Bankkartennummer ein",
	"请选择银行":"Bitte wählen Sie eine Bank aus",
	"数据为空":"Die Daten sind leer",
	"下注金额":"Wettbetrag",
	"下单时间":"Bestellzeit",
	"结算时间":"Zahlungsfrist",
	"充值":"neu laden",
	"提现": "Geld abheben",
	"我的钱包":"meine Brieftasche",
	"余额(元)":"Guthaben (€)",
	"个人中心":"Persönliches Zentrum",
	"登录密码": "Login-Passwort",
	"任务记录":"Aufgabenregistrierung",
	"系统公告": "Systemankündigung",
	"在线客服":"Online-Kundenservice",
	"退出登录": "Abmelden",
	"请完成任务单后进入":"Bitte füllen Sie die Aufgabenliste aus, bevor Sie eintreten",
	"请联系客服充值":"Bitte kontaktieren Sie den Kundenservice, um aufzuladen",
	"请设置收款卡":"Bitte richten Sie eine Zahlungskarte ein",
	"功能已禁用":"Funktion deaktiviert",
	"账号下线":"Offline-Konto",
	"登录/注册": "Anmeldung/Registrierung",
	"登录可享受更多服务":"Melden Sie sich an, um weitere Dienste zu nutzen",
	"基本信息":"Grundlegende Informationen",
	"头像":"Avatar",
	"选择头像": "Wähle einen Avatar",
	"确定": "Natürlich",
	"取消": "Stornieren",
	"真实姓名":"richtiger Name",
	"未设置":"nicht geklärt",
	"性别": "Geschlecht",
	"男":"männlich",
	"女": "weiblich",
	"未知": "unbekannt",
	"绑定信息":"verbindliche Angaben",
	"已绑定":"Verwandt",
	"无":"keiner",
	// "系统公告": "Systemankündigung",
	"收款卡信息": "Informationen zur Zahlungskarte",
	"添加收款卡":"Fügen Sie eine Zahlungskarte hinzu",
	"提示:请绑定大型商业银行,如需修改,请您联系在线客服":"Tipp: Bitte gehen Sie eine Partnerschaft mit einer großen Geschäftsbank ein. Wenn Sie es ändern müssen, wenden Sie sich bitte an den Online-Kundendienst.",
	"请设置姓名后再绑定银行卡":"Bitte geben Sie Ihren Namen an, bevor Sie die Bankkarte verknüpfen.",
	"修改登录密码":"Login-Passwort ändern",
	"旧密码":"Altes Passwort",
	"请输入您的旧密码":"Bitte geben Sie Ihr altes Passwort ein",
	"新密码": "Neues Passwort",
	"请输入您的新密码":"Bitte geben Sie Ihr neues Passwort ein",
	"请再次输入您的新密码":"Bitte geben Sie Ihr neues Passwort erneut ein",
	"保存":"zu schützen",
	"修改真实姓名":"Ändern Sie Ihren richtigen Namen",
	"姓名":"Name",
	"请输入真实姓名":"Bitte geben Sie Ihren richtigen Namen ein",
	"为了您账户安全,真实姓名需要与绑定银行卡姓名一致":"Zur Sicherheit Ihres Kontos muss Ihr richtiger Name mit dem Namen auf der verknüpften Bankkarte übereinstimmen..",
	"请勿重复设置":"Wiederholen Sie die Einstellungen nicht.",
	"性别修改":"Geschlechtsmodifikation",
	"提现中心":"Sammelzentrum",
	"提现记录":"Auszahlungsdateien",
	"提现金额(元)": "Auszahlungsbetrag (€)",
	// "全部": "alle",
	"1.单笔限额：最低": " 1. Einzeltransaktionslimit: Minimum",
	"元，最高":"der €, der höchste",
	"2.提现次数：一天最高提现": "2. Anzahl der Abhebungen: Maximale Abhebung an einem Tag",
	"次":"fréquence",
	"3.到账时间：一般到账时间在5分钟左右，最快2分钟内到账":"3. Zahlungszeit: Im Allgemeinen beträgt die Zahlungszeit etwa 5 Minuten und die schnellste Zeit beträgt 2 Minuten.",
	"限额说明":"Beschreibung des Limits",
	"余额":"Gleichgewicht",
	"马上提现": "Sofort Geld abheben",
	"请填写正确的金额":"Bitte geben Sie den korrekten Betrag ein",
	// "提现记录":"Zahlungsdaten",
	// "数据为空":"Die Daten werden gelesen",
	"说明": "Sommer",
	"金额":"Menge",
	"提交时间":"Regenerationszeit",
	"审核时间": "Revisionszeit",
	"没有更多了": "nicht mehr",
	"播放":"Spiele",
	"次播放":"Spiel",
	// "热门推荐":"Beliebte Empfehlungen",
	// "账号下线":"Offline-Konto",
	"请充值后观看视频": "Auch wenn es neu ist, gibt es ein Video ansehen",
	"填写收款卡": "Füllen Sie die Zahlungskarte aus",
	// "任务记录":"Aufgabenregistrierung",
	"选妃详情":"Details zur Auswahl der Konkubinen",
	// "我的":"meins",
	"视频":"Video",
	"游戏":"Spiel",
	// "在线客服":"Online-Kundenservice",
	"设置":"Einrichtung",
	// "修改真实姓名":"Ändern Sie Ihren richtigen Namen",
	"修改性别":"Geschlecht ändern",
	"登录密码管理":"Login-Passwortverwaltung",
	"详情页面":"Detailseite",
	"视频播放":"Videowiedergabe",
	"请填写完整": " Bitte füllen Sie das gesamte Formular aus.",
	"两次密码输入不一致": "Die beiden Passworteinträge sind inkonsistent",
	"写真": "Foto",
	"现在预约": "Vereinbaren Sie jetzt einen Termin",
	"余额不足":"Unzureichendes Gleichgewicht",
	"扣款失败":"Abzugsfehler",
	"下注异常":"Ausnahme beim Wetten",
	"投注成功":"erfolgreiche Wette",
	"参数异常":"Parameterausnahme",
	"数据不存在":"Die Daten existieren nicht",
	"数据获取失败":"Die Datenerfassung ist fehlgeschlagen",
	"数据获取成功":"Erfolgreiche Datenerfassung",
	"鉴权错误":"Authentifizierungsfehler",
	"更换头像成功":"Avatar erfolgreich ändern",
	"更新头像失败":"Avatar konnte nicht aktualisiert werden",
	"请输入真实姓名后再填写银行卡":"Bitte geben Sie Ihren richtigen Namen ein, bevor Sie Ihre Bankkartendaten eingeben.",
	"请输入提现密码后再填写银行卡":"Bitte geben Sie das Auszahlungspasswort und anschließend die Bankkartendaten ein.",
	"已设置过银行卡":"Sie haben bereits eine Bankkarte eingerichtet",
	"设置银行卡成功":"Bankkarte erfolgreich eingerichtet",
	"设置银行卡失败":"Die Einrichtung der Bankkarte ist fehlgeschlagen",
	"设置提现密码成功":"Auszahlungspasswort erfolgreich festgelegt",
	"设置提现密码失败":"Das Auszahlungskennwort konnte nicht festgelegt werden.",
	"修改密码成功":"Passwort erfolgreich geändert",
	"修改密码失败":"Die Passwortänderung ist fehlgeschlagen",
	"设置姓名成功":"Name erfolgreich festgelegt",
	"设置姓名失败":"Name konnte nicht festgelegt werden",
	"设置性别成功":"Sex erfolgreich definieren",
	"设置性别失败":"Geschlecht kann nicht definiert werden",
	"打码量不足":"Unzureichendes Codiervolumen",
	"提现金额不能少于":"Der Auszahlungsbetrag darf nicht geringer sein als",
	"提现金额不能大于":"Der Auszahlungsbetrag darf nicht höher sein als",
	"当日提现次数已用完":"Die Anzahl der Abhebungen für den Tag ist erschöpft",
	"余额不足":"Unzureichendes Gleichgewicht",
	"提现失败":"Die Auszahlung ist fehlgeschlagen",
	"提现成功":"Erfolgreich entfernen",
	"扣款失败":"Abzugsfehler",
	"结算中":"Vorschriften",
	"已结算":"Herrscher",
	"盈利":"profitieren",
	"亏损":"Verlust",
	"待结算":"Warten auf Zahlung",
	"获取信息成功":"Informationen erfolgreich eingeholt",
	"待审核":"Ausstehende Überprüfung",
	"审核成功":"Prüfung bestanden",
	"审核退回":"Prüfung bestanden",
	"网络异常，请重新登录":"Netzwerkanomalie, bitte stellen Sie die Verbindung erneut her",
	"用户不存在":"Der Benutzer existiert nicht",
	"密码错误":"Falsches Passwort",
	"账号被禁用":"Konto ist deaktiviert",
	"登录成功":"Verbindung erfolgreich",
	"用户名不能存在中文":"Benutzername darf auf Chinesisch nicht existieren",
	"用户名位数错误":"Falsche Anzahl von Ziffern im Benutzernamen",
	"密码位数错误":"Falsche Passwortziffern",
	"邀请码不能为空":"Der Einladungscode darf nicht leer sein",
	"邀请码不存在":"Der Einladungscode existiert nicht",
	"注册成功":"Registrierung erfolgreich",
	"注册失败":"Die Registrierung ist fehlgeschlagen",
	"用户已存在":"Benutzer existiert bereits",
}
